// NativeTabs imports native-only CSS that Metro web cannot bundle. Web is excluded by
// useIsNativeTabBarEnabled, so TabsLayoutGate never renders this fallback.
export default function NativeTabsLayout() {
  return null;
}
